import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import _ from 'lodash';

import { PRIVATE_CHANNEL_NAME } from 'src/app/constants';
import { SlackChannel } from 'src/models';
import { MessageService } from 'src/services/message.service';

import { BaseChannelSelector } from './base-channel-selector.directive';
import { ChannelSelectorModalComponent } from './channel-selector-modal/channel-selector-modal.component';

@Component({
  selector: 'app-channel-selector',
  templateUrl: './channel-selector.component.html',
  styleUrls: ['./channel-selector.component.css'],
})
export class ChannelSelectorComponent extends BaseChannelSelector {
  @Input() channel?: SlackChannel;

  @Input() override initialButtonText = 'Link to a channel';

  @Input() public defaultInternalOnly = false;

  @Input() public defaultExternalOnly = false;

  @Input() public hideChannelTypeFilter = false;

  @Input() public hideSecondaryTeams = true;

  @Input() public hideUnlinkButton = false;

  @Input() public hideLinkedToText = false;

  @Input() public disabled = false;

  @Output() channelDidChange = new EventEmitter<SlackChannel | undefined>();

  constructor(
    modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private msgSrvc: MessageService,
  ) {
    super(modalCtrl);
  }

  async openModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: ChannelSelectorModalComponent,
      componentProps: {
        selectedChannel: this.channel,
        defaultInternalOnly: this.defaultInternalOnly,
        defaultExternalOnly: this.defaultExternalOnly,
        hideChannelTypeFilter: this.hideChannelTypeFilter,
        hideSecondaryTeams: this.hideSecondaryTeams,
      },
    });
    modal.present();

    const { data } = await modal.onDidDismiss();
    if (data?.hasOwnProperty('channel')) {
      this.setChannel(data.channel);
    }
  }

  async clearSelection(): Promise<void> {
    const subHeader = "We'll disconnect this link, though conversations will still be visible in the dashboard";
    const alert = await this.alertCtrl.create({
      header: 'Are you sure?',
      subHeader,
      buttons: [
        {
          text: 'Nevermind',
        },
        {
          text: 'Confirm',
          handler: async () => {
            try {
              this.setChannel(undefined);
            } catch (e) {
              this.msgSrvc.showError(e);
            }
          },
        },
      ],
    });
    alert.present();
  }

  setChannel(channel?: SlackChannel): void {
    if (this.channel?.id !== channel?.id) {
      this.channel = channel;
      this.channelDidChange.emit(this.channel);
    }
  }

  getDisplayText(): string {
    if (!this.channel) {
      return this.initialButtonText;
    }

    return this.hideLinkedToText
      ? this.channel.name ?? PRIVATE_CHANNEL_NAME
      : `Linked to ${this.channel.name ?? PRIVATE_CHANNEL_NAME}`;
  }
}
